let BASE_API = 'https://ais.adaptconcepts.com/october/'
let isDev = false
if (window.location && window.location.hostname &&
  (window.location.hostname.includes('adaptconcepts'))) {
  // development
  BASE_API = 'https://ais.adaptconcepts.com/october/'
  // BASE_API = 'https://www.alliedinstructional.com/october/' // temporary
  isDev = true
}
let isLive = false
if (window.location && window.location.hostname &&
  window.location.hostname.includes('prod.alliedinstructional')) {
  // live
  BASE_API = 'https://prod.alliedinstructional.com/october/'
  isLive = true
} else if (window.location && window.location.hostname &&
  (window.location.hostname.includes('www.alliedinstructional') ||
  (window.location.hostname.includes('alliedinstructional')))) {
  // live
  BASE_API = 'https://www.alliedinstructional.com/october/'
  isLive = true
}
// if (window.location && window.location.hostname &&
//   window.location.hostname.includes('aislive')) {
//   // live
//   BASE_API = 'http://aislive.adaptconcepts.com/october/'
//   isLive = true
// }
let isLocalhost = false
if (window.location && window.location.hostname &&
  (window.location.hostname.includes('localhost') || window.location.hostname.includes('127.0.0.1'))) {
  // localhost
  BASE_API = 'http://localhost/october_ais/' // dev
  // BASE_API = 'https://ais.adaptconcepts.com/october/' // staging
  // BASE_API = 'https://prod.alliedinstructional.com/october/' // live - pre
  // BASE_API = 'https://www.alliedinstructional.com/october/' // live
  isLocalhost = true
}

const Constants = Object.freeze({
  BASE_API,
  BASE_API_BARE: 'https://ais.com/',
  isDev,
  isLive,
  isLocalhost,

  OptionsYesNo: {
    YES: 1,
    NO: 0,
  },

  OPTIONS_YES_NO: [{
    id: 1,
    label: 'Yes'
  }, {
    id: 0,
    label: 'No'
  }],

  Color: {
    GREEN: '#008769',
    LIGHTGREEN: '#d7e1e0',
    BEIGE: '#f4f4ec'
  }
})

export default Constants
